import utils from "../../../utils/utils.js";

export default {
    async fetchFeedList(context, payload) {

        context.commit("setFeedList", payload);
    },
    async fetchFeedCategory(context) {
        const responseCategory = await utils.utility.fetch(`api/Editor/GetCategories`, "GET", null, null);

        const responseData = {
            mainCategory: responseCategory.data.mainCategories,
            subCategory: responseCategory.data.subCategories,
            detailCategory: responseCategory.data.detailCategories
        };

        context.commit("setFeedCategory", responseData);
    },
    async assignMainCategoryId(context, payload) {
        const feedId = parseInt(payload.feedId);
        const opCommentId = parseInt(payload.opCommentId);
        const isHierarchic = payload.isHierarchic;

        const responseData = await utils.utility.fetch(
            'api/Editor/UpdateFeedCategories',
            "POST",
            null,
            {
                feedId: feedId,
                opCommentId: opCommentId,
                opStatusId: null,
                opTypeId: null
            }
        );
        if (isHierarchic)
        {
            context.commit("setHierarchicMainCatId", { opCommentId: responseData.data.opCommentId, feedId: feedId, isHierarchic: isHierarchic });
            context.commit("setHierarchicSubCatId", { opStatusId: responseData.data.opStatusId, feedId: feedId, isHierarchic: isHierarchic });
            context.commit("setHierarchicDetailCatId", { opTypeId: responseData.data.opTypeId, feedId: feedId });
        }   
            
    },
    async assignSubCategoryId(context, payload) {

        const feedId = payload.feedId;
        const opStatusId = payload.opStatusId;
        const isHierarchic = payload.isHierarchic;

        const responseData = await utils.utility.fetch(
            'api/Editor/UpdateFeedCategories',
            'POST',
            null,
            {
                feedId: parseInt(feedId),
                opStatusId: parseInt(opStatusId),
                opCommentId: null,
                opTypeId: null
            }
        );
        if (isHierarchic)
            context.commit("setHierarchicSubCatId", { opStatusId: responseData.data.opStatusId, feedId: feedId, isHierarchic: isHierarchic });

    },
    async assignDetailCategoryId(context, payload) {

        const feedId = payload.feedId;
        const opTypeId = payload.opTypeId;
        const responseData = await utils.utility.fetch(
            'api/Editor/UpdateFeedCategories',
            'POST',
            null,
            {
                feedId: parseInt(feedId),
                opStatusId: null,
                opCommentId: null,
                opTypeId: parseInt(opTypeId)
            }
        );
        context.commit("setHierarchicDetailCatId", { opTypeId: responseData.data.opTypeId, feedId: feedId });
    },
    async postFeedCategory(context, payload) {
        const feedId = parseInt(payload.feedId);
        const opCommentId = parseInt(payload.opCommentId);
        const opStatusId = parseInt(payload.opStatusId);
        const opTypeId = parseInt(payload.opTypeId);
        await utils.utility.fetch(
            'api/Editor/UpdateFeedCategories',
            "POST",
            null,
            {
                feedId: feedId,
                opCommentId: opCommentId,
                opStatusId: opStatusId,
                opTypeId: opTypeId
            }
        );
    }
}